import { RedoCarrierName } from "@redotech/redo-fulfillment-rate-common/carrier-account";
import * as z from "zod";
import { null as zNull } from "zod";

/** Status-only carrier read: account names for brand folding, without the EasyPost OAuth refresh getCarrierAccounts performs. */
export const getCarrierAccountNames = {
  name: "getCarrierAccountNames" as const,
  input: zNull(),
  output: z.object({ carrierNames: z.array(z.nativeEnum(RedoCarrierName)) }),
};
